
<header class="header">
    <div class="row align-items-center">
        <div class="col ms-1 my-1 py-1">
            <a routerLink="home"><img src="/assets/images/wino_logo_01_big_transparent_490.png" alt="wino logo" title="Wino Logo"></a>
        </div>
        <div class="col my-1 py-1 me-2">
            <div class="float-end" style="text-align: center;">
                <!-- 
                <div class="my-0 py-0">
                    <span class="fs-6">{{this.actualDate | date: "dd MMM, HH:mm"}}</span><br>
                </div>
                -->
                <div *ngIf="permissionService.isAuthenticated(); else elseBlock">
                    <div class="dropdown mb-n1" data-bs-toggle="dropdown">
                        <div class="mb-n2 mt-2">
                            <a type="button" class="btn px-0 py-0">
                                <span class="bi-person-circle text-primary fs-2" title='{{getClientCitizenFullName()}}'></span>
                            </a>
                        </div>
                        <span class="btn text-primary px-0 py-0">{{permissionService.getClientUserInfoNickname()}}</span>
                        <a *ngIf="permissionService.getClientCitizenInfoFullName()" type="button" class="btn ps-1 pe-0 py-0">
                            <span winoTooltip tooltipText={{getClientCitizenFullName()}} tooltipSecondaryText={{getClientLegalEntityInfoReference()}}
                                tooltipPosition="left" class="bi-info-circle text-primary fs-5" ></span>
                        </a>
                        <ul class="dropdown-menu">
                                <span *ngIf="permissionService.isAuthorized(membershipModuleName + '.PermissionsComponent')">
                                    <li><a class="dropdown-item btn text-primary" (click)="admin()">admin</a></li>
                                    <li><hr class="dropdown-divider"></li>
                                    <li><hr class="dropdown-divider"></li>
                                </span>
                            <li><a class="dropdown-item btn text-primary" (click)="profile()">Profilo</a></li>
                            <li><hr class="dropdown-divider"></li>
                            <li><a class="dropdown-item btn text-primary" (click)="logout()">logout</a></li>
                        </ul>
                    </div>
                </div>
                <ng-template #elseBlock>
                    <div class="dropdown mb-n1" data-bs-toggle="dropdown">
                        <div class="mb-n2 mt-2">
                            <a class="btn px-0 py-0">
                                <span class="bi-person-plus text-primary fs-2"></span>
                            </a>
                        </div>
                        <span class="btn text-primary px-0 py-0">benvenuto</span>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item btn text-primary" (click)="login()">login</a></li>
                            <li><hr class="dropdown-divider"></li>
                            <li><a class="dropdown-item btn text-primary" (click)="register()">registrati</a></li>
                        </ul>
                    </div>
                </ng-template>
<!--
                <div *ngIf="permissionService.isAuthenticated(); else elseBlock">
                    <div class="dropdown mb-n1">
                        <span data-bs-toggle="dropdown">
                            <div class="mb-n2 mt-2">
                                <a href="#"><span class="bi-person-circle text-primary fs-2"></span></a>
                            </div>
                            <label class="text-primary">{{permissionService.getUserNickname()}}</label>
                        </span>
                        <ul class="dropdown-menu">
                            <span *ngIf="permissionService.getCitizenFullName()">
                                <li>
                                    {{permissionService.getCitizenFullName()}}
                                </li>
                            </span>
                            <span *ngIf="permissionService.isAuthorized(membershipModuleName + '.PermissionsComponent')">
                                <li><a class="dropdown-item btn text-primary" (click)="admin()">admin</a></li>
                                <li><hr class="dropdown-divider"></li>
                                <li><hr class="dropdown-divider"></li>
                            </span>
                            <li><a class="dropdown-item btn text-primary" (click)="profile()">Profilo</a></li>
                            <li><hr class="dropdown-divider"></li>
                            <li><a class="dropdown-item btn text-primary" (click)="logout()">logout</a></li>
                        </ul>
                    </div>
                </div>
                <ng-template #elseBlock>
                    <div class="dropdown mb-n1">
                        <span data-bs-toggle="dropdown">
                            <div class="mb-n2 mt-2">
                                <a href="#"><span class="bi-person-plus text-primary fs-2"></span></a>
                            </div>
                            <a href="#" class="text-primary text-decoration-none">benvenuto</a>
                        </span>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item btn text-primary" (click)="login()">login</a></li>
                            <li><hr class="dropdown-divider"></li>
                            <li><a class="dropdown-item btn text-primary" (click)="register()">registrati</a></li>
                        </ul>
                    </div>
                </ng-template>
-->

<!-- 
                <ng-template #elseBlock>
                    <div class="dropdown mb-n2">
                        <em class="bi bi-person-plus text-primary fs-2" data-bs-toggle="dropdown"></em>
                        <ul class="dropdown-menu">
                            <li><button class="btn" (click)="login()">login</button></li>
                            <li><button class="btn" (click)="register()">registrati</button></li>
                        </ul>
                    </div>
                    <div class="dropdown my-0 py-0">
                        <label class="text-primary" data-bs-toggle="dropdown">benvenuto</label>
                        <ul class="dropdown-menu">
                            <li><button class="btn" (click)="login()">login</button></li>
                            <li><button class="btn" (click)="register()">registrati</button></li>
                        </ul>
                    </div>
                </ng-template>
            -->
            </div>
        </div>
    </div>
</header>

<!--
<nav class="nav fixed-top" style="background-color: green; height:100px;">
    <div class="container-sm">
        <a class="navbar-brand" style="color: aliceblue; font-size: 40px; padding-top: 20px;" href="#">Wino</a>
        <a class="navbar-brand" style="color: aliceblue; font-size: 22px; padding-top: 20px;" href="#">Cantine e dintorni</a>
        <div class="navbar-text">
            <a *ngIf="authService.isUserAuth()" class="nav-link" href="/createPost" style="color: aliceblue;">New post</a>
        </div>
        <div class="navbar-text">
            <a *ngIf="authService.isUserAuth()" class="nav-link" href="/approvePost" style="color: aliceblue;">Approve post</a>
        </div>
        <div class="navbar-text">
            <a *ngIf="authService.isUserAuth()" class="nav-link" style="color: aliceblue; text-align: right;">Ciao {{authService.getUserAuth()}}</a>
            <a *ngIf="! authService.isUserAuth()" class="nav-link" href="/login" style="color: aliceblue; text-align: right;">Login</a>
        </div>
        <div class="navbar-text">
            <a *ngIf="authService.isUserAuth()" class="nav-link" href="#" (click)="logout()" style="color: aliceblue;; text-align: right;">Logout</a>
            <a *ngIf="! authService.isUserAuth()" class="nav-link" href="/registerUser" style="color: aliceblue;; text-align: right;">Register</a>
        </div>
    </div>
</nav>
-->

<!--
    <div class="header">
    <div class="container">
        <div class="row">
            <div class="col-md-1.5">
                <h1><a href="" class="title">Wino</a></h1>
            </div>
            <div class="col-md-3">
                <a href="" class="sub-title">Cantine e dintorni</a>
            </div>
            <foo *ngIf="authService.isUserAuth()">
                <div class="col-md-4">
                    <a href="/addPost" class="new-post btn btn-default">New Post</a>
                </div>
                <div class="col-md-5" >
                    <a href="/login" class="login btn btn-default">Ciao {{authService.getUserAuth()}}</a>
                </div>
                <div class="col-md-6" >
                    <a href="/registerUser" class="register btn btn-default">Logout</a>
                </div>
            </foo>
            <foo *ngIf="! authService.isUserAuth()">
                <div class="col-md-3" >
                    <a href="/login" class="login btn btn-default">Login</a>
                </div>
                <div class="col-md-3" >
                    <a href="/registerUser" class="register btn btn-default">Register</a>
                </div>
            </foo>
        </div>
    </div>
</div>
-->